import { useParams, useNavigate } from "react-router-dom";
import React, { useState, useEffect } from "react";
import styles from './DetallePaso.module.css';
import imageDef from "./images/MIS_INTERESESFT.png";
import ImgIl from "./images/IMAGEN.png";
import { generarCertificadoBase64 } from "../../Header/Themes/Certificado";
import {
    FaTrash, FaEdit, FaEye, FaSadCry,
    FaBrain,
    FaMagic,
    FaRocket,
    FaDog,
    FaCat,
    FaBook,
    FaMusic,
    FaArrowLeft, 
    FaPuzzlePiece
} from 'react-icons/fa';
import {useAuth} from "../../Auth/AuthContext";
import Swal from "sweetalert2";

const iconMap = {
    FaTrash: FaTrash,
    FaEdit: FaEdit,
    FaEye: FaEye,
    FaSadCry: FaSadCry,
    FaBrain: FaBrain,
    FaMagic: FaMagic,
    FaRocket: FaRocket,
    FaDog: FaDog,
    FaCat: FaCat,
    FaBook: FaBook,
    FaMusic: FaMusic,
    FaPuzzlePiece: FaPuzzlePiece,
};

const DetallePaso = () => {
    const { pa_clave } = useParams();
    const { getToken, userData } = useAuth(); 
    const token = getToken();
    const navigate = useNavigate();
    const [paso, setPaso] = useState(null);
    const [elementos, setElementos] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [estadoCompletitud, setEstadoCompletitud] = useState(null);

    const handleVolverTemas = () => {
        navigate('/temas');
    };

    useEffect(() => {
        const fetchPasoDetails = async () => {
            try {                
                const pasoResponse = await fetch(`${process.env.REACT_APP_API_URL}/pasos/paso/${pa_clave}`, { 
                    headers: { 
                        'Authorization':  `Bearer ${token}`
                    }
                });
                const pasoData = await pasoResponse.json();
                setPaso(pasoData?.[0] || null);

                const elementosResponse = await fetch(
                    `${process.env.REACT_APP_API_URL}/pasos/paso-elementos/${pa_clave}/usuario/${userData.id}`, { 
                        headers: { 
                        'Authorization':  `Bearer ${token}`
                    }
                    }
                );

                if (elementosResponse.ok) {
                    const elementosData = await elementosResponse.json();
                    setElementos(elementosData);
                } else if (elementosResponse.status === 404) {
                    setElementos([]);
                } else {
                    throw new Error('Error al obtener los elementos del paso');
                }
            } catch (error) {
                console.error('Error al cargar datos:', error);
                setError(error.message);
            } finally {
                loading && setLoading(false);
            }
        };

        if (pa_clave) {
            fetchPasoDetails();
        }
    }, [pa_clave]);

    const actualizarProgresoPaso = async (porcentaje, completado = false) => {
        try {
            const bodyData = {
                usuario_id: userData.id,
                paso_id: Number(pa_clave),
                progreso: porcentaje,
                completado: completado
            };

            const response = await fetch(`${process.env.REACT_APP_API_URL}/pasos/actualizar-progreso-paso`, {
                method: 'POST',
                headers: {
                    'Authorization':  `Bearer ${token}`,
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(bodyData)
            });

            if (!response.ok) {
                throw new Error('Error al actualizar progreso');
            }

            return await response.json();
        } catch (error) {
            console.error('Error actualizando progreso:', error);
            throw error;
        }
    };

    const verificarCompletitud = async (elementos) => {
        try {
            // Filtrar elementos por tipo
            const secciones = elementos.filter(el => el.tipo === 'seccion');
            const tests = elementos.filter(el => el.tipo === 'test');

            let totalElementos = elementos.length;
            let elementosCompletos = 0;

            // Procesar secciones - verificar que tengan progreso 100
            secciones.forEach(seccion => {
                if (seccion.progreso_seccion === 100) {
                    elementosCompletos += 1;
                }
            });

            // Procesar tests - verificar que se_completado sea 1
            tests.forEach(test => {
                // Verificar directamente el campo test_completado que viene de se_completado
                if (test.test_completado === 1) {
                    elementosCompletos += 1;
                }
            });

            const porcentaje = totalElementos > 0 ? Math.round((elementosCompletos / totalElementos) * 100) : 0;

            let pasoCompletado = false;
            let mensaje = "";

            if (elementos.length === 0) {
                mensaje = "No hay elementos disponibles en este paso";
            } else {
                // El paso está completo si todos los elementos están completos
                pasoCompletado = elementosCompletos === totalElementos;
                
                if (pasoCompletado) {
                    mensaje = "¡Paso completado!";
                } else {
                    const pendientesSecciones = secciones.filter(s => s.progreso_seccion !== 100).length;
                    const pendientesTests = tests.filter(t => t.test_completado !== 1).length;
                    
                    if (pendientesSecciones > 0 && pendientesTests > 0) {
                        mensaje = "Completa las secciones de lectura y realiza los tests para avanzar.";
                    } else if (pendientesSecciones > 0) {
                        mensaje = "Lee con atención los contenidos de este paso para avanzar.";
                    } else if (pendientesTests > 0) {
                        mensaje = "Completa los tests pendientes para finalizar el paso.";
                    }
                }
            }

            await actualizarProgresoPaso(porcentaje, pasoCompletado);

            return {
                completo: pasoCompletado,
                mensaje: mensaje,
                progreso: porcentaje,
                estadisticas: { 
                    completados: elementosCompletos, 
                    total: totalElementos, 
                    porcentaje,
                    secciones: {
                        total: secciones.length,
                        completas: secciones.filter(s => s.progreso_seccion === 100).length
                    },
                    tests: {
                        total: tests.length,
                        completas: tests.filter(t => t.test_completado === 1).length
                    }
                }
            };

        } catch (error) {
            console.error('Error en verificarCompletitud:', error);
            throw error;
        }
    };

    useEffect(() => {
        const obtenerEstado = async () => {
            if (elementos.length > 0) {
                try {
                    const resultado = await verificarCompletitud(elementos);
                    setEstadoCompletitud(resultado);
                } catch (err) {
                    console.error(err);
                }
            }
        };

        obtenerEstado();
    }, [elementos]);

    const handleContinuarP = async () => {
        if (estadoCompletitud?.progreso !== 100) {
            Swal.fire({
                title: 'Paso incompleto',
                text: 'Debes completar todos los elementos antes de continuar',
                icon: 'warning',
                confirmButtonText: 'Entendido',
                customClass: { popup: 'popupbonito' },
            });
            return;
        }

        try {
            // 👇 CHISMOSOS ACTIVADOS PARA VER QUÉ PASA EN LA CONSOLA (F12)
            console.log("Datos completos del paso:", paso);
            console.log("El paso actual es el número:", paso?.pa_numero);

            // 👇 LA MAGIA: Usamos == (dos iguales) por si el 8 viene como texto "8"
            if (paso?.pa_numero == 5) { 
                console.log("¡Último paso detectado! Generando PDF silencioso...");
                
                Swal.fire({
                    title: 'Generando tu constancia...',
                    text: 'Por favor espera un momento.',
                    allowOutsideClick: false,
                    didOpen: () => { Swal.showLoading(); }
                });

                try {
                    // 1. Obtener la data para dibujar
                    const dataResponse = await fetch(`${process.env.REACT_APP_API_URL}/pasos/generar-certificado/${userData.id}`, {
                        headers: { 'Authorization': `Bearer ${token}` }
                    });
                    
                    if (dataResponse.ok) {
                        const certificateData = await dataResponse.json();
                        if (certificateData.userData) {
                            // 2. Generar Base64
                            const pdfBase64 = await generarCertificadoBase64(certificateData.userData);
                            console.log("PDF generado en Base64. Enviando al backend...");
                            
                            // 3. Mandar el PDF a tu nuevo endpoint POST
                            await fetch(`${process.env.REACT_APP_API_URL}/pasos/verificar-pasos-completados/${userData.id}`, {
                                method: 'POST',
                                headers: {
                                    'Authorization': `Bearer ${token}`,
                                    'Content-Type': 'application/json'
                                },
                                body: JSON.stringify({ pdfBase64: pdfBase64 }) // Aseguramos que se llame pdfBase64
                            });
                        }
                    }
                } catch (pdfError) {
                    console.error("Error silencioso con el PDF:", pdfError);
                }
                
                Swal.close();
            }

            // Continuar con la navegación normal
            const response = await fetch(`${process.env.REACT_APP_API_URL}/pasos/siguiente-paso/${paso.pa_numero}`, {
                headers: { 'Authorization':  `Bearer ${token}` }
            });

            if (response.ok) {
                const siguientePasoData = await response.json();
                if (siguientePasoData?.length > 0) {
                    navigate(`/paso/${siguientePasoData[0].pa_clave}`);
                } else {
                    Swal.fire({
                        title: '¡Felicidades!',
                        text: '¡Has completado todos los pasos!',
                        icon: 'success',
                        confirmButtonText: 'Entendido',
                        customClass: { popup: 'popupbonito' },
                    }).then(() => navigate('/temas'));
                }
            } else {
                navigate('/temas');
            }
        } catch (error) {
            console.error('Error:', error);
        }
    };
    const handleAnteriorP = async () => {
        try {
            const response = await fetch(`${process.env.REACT_APP_API_URL}/pasos/anterior-paso/${paso.pa_numero}`,{
                headers: { 
                    'Authorization':  `Bearer ${token}`
                }
            });
            if (response.ok) {
                const anteriorPasoData = await response.json();
                if (anteriorPasoData?.length > 0) {
                    navigate(`/paso/${anteriorPasoData[0].pa_clave}`);
                } else { 
                    Swal.fire({
                        title: 'No hay pasos anteriores disponibles', 
                        icon: 'info', 
                        timer: 1000,
                        showConfirmButton: false, 
                        customClass: { 
                            popup: 'popupbonito', 
                        },
                    })
                }
            } else if (response.status === 404) {
                Swal.fire({
                        title: 'No hay pasos anteriores disponibles', 
                        icon: 'info', 
                        timer: 1000,
                        showConfirmButton: false, 
                        customClass: { 
                            popup: 'popupbonito', 
                        },
                })
            } else { 
                throw new Error('Error al buscar paso anterior');
            }
        } catch (error) {
            console.error('Error al buscar paso anterior:', error);
        }
    };

    const handleViewSection = (se_clave) => {
        navigate(`seccion/${se_clave}`);
    };

    const handleViewTest = (te_clave) => {
        navigate(`test/${te_clave}`);
    };
    
    // Función auxiliar para mostrar el estado de un test
    const getTestStatus = (test) => {
        // Si el test está completado (se_completado = 1)
        if (test.test_completado === 1) {
            return {
                texto: "Completado",
                clase: "completado",
                progreso: 100
            };
        } 
        // Si hay progreso pero no está completado
        else if (test.pregunta_actual > 0 && test.num_preguntas > 0) {
            const progreso = Math.round((test.pregunta_actual / test.num_preguntas) * 100);
            return {
                texto: `En progreso (${test.pregunta_actual}/${test.num_preguntas})`,
                clase: "en-progreso",
                progreso: progreso
            };
        } 
        // Test no iniciado
        else {
            return {
                texto: "Pendiente",
                clase: "pendiente",
                progreso: 0
            };
        }
    };

    if (loading) {
        return (
            <div className={styles.loadingContainer}>
                <div className={styles.loadingContent}>
                    <div className={styles.loadingSpinner}></div>
                    <p className={styles.loadingText}>Cargando datos...</p>
                </div>
            </div>
        );
    }

    if (!paso) {
        return (
        <div className={styles.loadingContainer}>
            <div className={styles.loadingContainer}> 
                <p className={styles.loadingText}> Paso no encontrado :(</p>
            </div>
        </div>
        )
    }

return (
    <div>
        <div className={styles.vistaContainer}>
            <button onClick={handleVolverTemas} className={styles.btnBack}> <FaArrowLeft /> Volver</button>
            <div className={styles.cuerpoContainer}>
                <div className={styles.columContainer}>
                    <div className={styles.imageWrapper}>
                       <img
    src={
        paso.pa_imagen
            ? `${process.env.REACT_APP_API_URL}/uploads/${paso.pa_imagen}`
            : imageDef
    }
    alt="Imagen paso"
/>
                    </div>
                    <div>
                        <h2>Paso {paso.pa_numero}: {paso.pa_titulo}</h2>
                        {estadoCompletitud && (
                            <div className={`${styles['mensaje-completitud']} ${estadoCompletitud.completo ? styles.completo : styles.incompleto}`}>
                                <h3>{estadoCompletitud.mensaje} ({estadoCompletitud.progreso}%)</h3>
                            </div>
                        )}
                    </div>
                    <p>{paso.pa_descripcion}</p>

                    <div className={styles.navigationButtons}>
                        <button onClick={handleAnteriorP} className={`${styles.btn} ${styles.btnVolver}`}>
                            Regresar
                        </button>
                        <button 
                            onClick={handleContinuarP} 
                            className={`${styles.btn} ${styles.btnContinuar} ${
                                estadoCompletitud?.progreso !== 100 ? styles.btnDisabled : ''
                            }`}
                            disabled={estadoCompletitud?.progreso !== 100}
                        >
                            Continuar
                        </button>
                    </div>
                </div>

                <div className={styles.columContainerSections}>
                    <h2>{paso.pa_nom_subtitulo}</h2>
                    {error && (
                        <div className={styles.mensajeError}>
                            {error}
                        </div>
                    )}

                    {/* Renderizar todos los elementos en orden */}
                    {elementos.map((elemento, index) => {
                        if (elemento.tipo === 'seccion') {
                            return (
                                <div
                                    key={`seccion-${elemento.id}`}
                                    className={`${styles.progressItemLink} ${styles.pasosCard}`}
                                    style={{ position: 'relative' }}
                                    onClick={() => handleViewSection(elemento.id)}
                                >
                                    <div className={styles.progressItem}>
                                      <img
    src={
        (elemento.icono || elemento.se_icono)
            ? `/images/misc/${elemento.icono || elemento.se_icono}`
            : ImgIl
    }
    alt={elemento.nombre || "Imagen sección"}
    style={{
        width: '100%',
        maxWidth: '160px',
        height: '120px',
        objectFit: 'contain',     /* 🎨 'contain' para que el ícono (cerebro, perrito, etc.) no se corte */
        borderRadius: '16px',
        margin: '0 auto 10px auto',
        display: 'block'
    }}
    onError={(e) => {
        // Si no encuentra la imagen en /images/misc/, busca en /uploads/ por si acaso
        if (!e.target.dataset.triedUploads) {
            e.target.dataset.triedUploads = 'true';
            e.target.src = `${process.env.REACT_APP_API_URL}/uploads/${elemento.icono || elemento.se_icono}`;
        } else {
            e.target.onerror = null;
            e.target.src = ImgIl; // Imagen de respaldo si falla ambas rutas
        }
    }}
/>
                                        <div className={styles.progressInfo}>
                                            <p>{elemento.nombre}</p>
                                            <div className={styles.progressBar}>
                                                <div className={styles.progress}
                                                    style={{ width: `${elemento.progreso_seccion || 0}%` }}></div>
                                            </div>
                                            <span>
                                                {elemento.progreso_seccion || 0}% Completado
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            );
                        } else if (elemento.tipo === 'test') {
                            // Obtener el estado del test usando la función auxiliar
                            const testStatus = getTestStatus(elemento);
                            
                            return (
                                <div
                                    key={`test-${elemento.id}`}
                                    className={`${styles.progressItemLink} ${elemento.test_completado === 1 ? styles.testCompletado : styles.testPendiente}`}
                                    onClick={() => handleViewTest(elemento.id)}
                                >
                                    <div className={styles.progressItem}>
                                        <div className={styles.cardIcon}>
                                            {iconMap[elemento.te_icon]
                                                ? React.createElement(iconMap[elemento.te_icon], { className: styles.customIcon })
                                                : <FaBrain className={styles.customIcon} />
                                            }
                                        </div>
                                        <div className={styles.progressInfo}>
                                            <p>{elemento.nombre}</p>
                                            <div className={styles.progressBar}>
                                                <div className={`${styles.progress} ${testStatus.clase}`}
                                                    style={{ width: `${testStatus.progreso}%` }}></div>
                                            </div>
                                            <span>
                                                {testStatus.texto}
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            );
                        }
                        return null;
                    })}
                </div>
            </div>
        </div>
    </div>
);
};

export default DetallePaso;